module.exports = __webpack_public_path__ + "static/media/selected_filter_mobile.4a9aca1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/selected_filter_mobile.svg
// module id = 760
// module chunks = 11